import { ZodError } from 'zod/v3';
import { AnalyticsProvider } from './interface';
import { resolveFiltroHubspot } from './hubspotFilterEvents';
import { analyticsEventSchema } from './schemaValidation';
import { AnalyticsEvent } from './types';

export class AnalyticsTracker {
  constructor(private readonly provider: AnalyticsProvider) {}

  track(event: AnalyticsEvent): void {
    const resolvedEvent = this.withFiltroHubspot(event);
    this.validate(resolvedEvent);
    this.provider.track(resolvedEvent);
  }

  private withFiltroHubspot(event: AnalyticsEvent): AnalyticsEvent {
    if (event.properties.filtro_hubspot !== undefined) {
      return event;
    }

    const filtroHubspot = resolveFiltroHubspot(
      event.event,
      event.properties.owner,
    );

    if (filtroHubspot === undefined) {
      return event;
    }

    return {
      ...event,
      properties: { ...event.properties, filtro_hubspot: filtroHubspot },
    };
  }

  private validate(event: AnalyticsEvent): void {
    try {
      analyticsEventSchema.parse(event);
    } catch (error) {
      if (error instanceof ZodError) {
        throw new Error(
          `AnalyticsEvent: ${
            error.issues[0].message
          } - ${error.issues[0]?.path?.join('.')}`,
        );
      }
      throw error;
    }
  }
}
